"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Aggregation of {@link Baseline Baselines} of a specific {@link Product Product} and {@link InternalSite Site}.
 * Independent of the source where the data come from – baselines vs. baselines.historic collections
 *   –> for forecast purposes vs. PromoOptEngine learning.
 *
 * @author OPt
 */


var BaselineAggregation =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(BaselineAggregation, _DomainObject_1$Domai);

  /**
   * @param productId internal ID of a {@link Product Product}
   * @param siteId internal ID of a {@link InternalSite Site}
   * @param amount baseline aggregation
   */
  function BaselineAggregation(productId, siteId, amount) {
    var _this;

    _classCallCheck(this, BaselineAggregation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaselineAggregation).call(this));
    _this.productId = productId;
    _this.siteId = siteId;
    _this.amount = amount;
    return _this;
  }

  return BaselineAggregation;
}(DomainObject_1.DomainObject);

exports.BaselineAggregation = BaselineAggregation;

BaselineAggregation.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(BaselineAggregation.name);
  return {
    productId: builder.id('productId'),
    siteId: builder.id('siteId'),
    amount: builder.num('amount')
  };
}();